import { z } from 'zod';

import { zodTaxCodeSchema } from '../validations';

export const zodUpdateTaxCodePayloadSchema = z.object({
  code: z.string().trim().max(64).nullable(),
  isReverseCharge: z.boolean(),
  name: z.string().trim().min(1).max(255),
  rate: z
    .string()
    .trim()
    .regex(/^\d{1,3}(?:\.\d{1,2})?$/)
    .refine((value) => Number(value) <= 100, {
      message: 'Rate must be between 0 and 100',
    }),
});

export const zodUpdateTaxCodeResponseSchema = zodTaxCodeSchema;
